module.exports = __webpack_public_path__ + "static/media/parachute3.aee86ddc.png";